import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import icon from './menu.svg';
export const MenuSvgComponent = () => {
    return (_jsxs("svg", { viewBox: '0 0 100 80', width: '17', height: '22', children: [_jsx("rect", { width: '100', height: '12', rx: '8', fill: '#828282' }), _jsx("rect", { y: '30', width: '100', height: '12', rx: '8', fill: '#828282' }), _jsx("rect", { y: '60', width: '100', height: '12', rx: '8', fill: '#828282' })] }));
};
export default icon;
